import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { downloadInBrowser } from 'utils/downloadInBrowser';
import { createGraphExportFileName } from '../helpers/createGraphExportFileName';
import { createGraphSvg } from './helpers/createGraphSvg';

export const exportToSvg: GraphCommandFactory = (cmdContext) => () => {
  const state = cmdContext.getState();
  const svg = createGraphSvg(state.graph, state.peekingAtHiddenNodes);

  downloadInBrowser(`${createGraphExportFileName(state)}.svg`, svg);
};
